import Vue from 'vue'
import { computed, onMounted, ref } from '@vue/composition-api'

import { useCurrentUser, useUserCompany } from '@composables'
import { LincolnNewGlobalUMRService } from '@services'

// Whether the current (non-superuser) company has new BDX items to review.
// Shared by the legacy header icon and the navigation drawer's BDX List badge.
export const useNewBDXItems = () => {
  const { isSuperUser } = useCurrentUser()
  const { id: companyId } = useUserCompany()

  const hasNewBDXItems = ref(false)

  const isVisible = computed(() => {
    if (isSuperUser.value || !companyId.value) return false

    return hasNewBDXItems.value
  })

  const checkNewBDXItems = async () => {
    if (!companyId.value) return

    try {
      const { data } = await LincolnNewGlobalUMRService.check(companyId.value)
      const { data: results } = data || {}

      hasNewBDXItems.value = results.exists
    } catch (_) {
      hasNewBDXItems.value = false
    }
  }

  onMounted(async () => {
    await checkNewBDXItems()

    Vue.prototype.$emitter.on('files-uploaded', async ({ type, success }) => {
      if (!success || 'bdx' !== type) return

      await checkNewBDXItems()
    })
  })

  return { companyId, isVisible, hasNewBDXItems }
}
